mutation CreateCustomField($customField: CreateCustomFieldInputFieldInput!) {
    createCustomField(input: {customField: $customField}) {
        customField {
            id
            field {
                name
                type
                filterTitle
                ... on FieldEnum {
                    options
                }
            }
        }
    }
}
